export const parseFloatFromString = (value) => {
  if (typeof value === 'number') return value;
  if (value === '' || value === null || value === undefined) return 0.0;
  return parseFloat(String(value).replace(/,/g, ''));
};
